import moment from 'moment';
import template from './filterBarDate.html';
import '../filterBarDate.scss';

/**
 * @ngdoc controller
 * @name OdsFilterBarDate
 * @description
 * This component renders the filterBar date filter.
 *
 * @requires OdsCalendar
 * @requires Moment
 */
class OdsFilterBarDate {
  constructor() {
    /**
     * The local reference for the Moment Object.
     * @type {Moment}
     */
    this.moment = moment;
    /**
     * The local reference for the calendar options.
     * @type {Object}
     */
    this.calendarOptions = {
      showMonths: 2,
      mode: 'range',
      enableTime: false,
      dateFormat: 'm/d/Y',
      allowInput: false,
    };
    /**
     * The minimum number of dates the user have to select.
     * @type {Object}
     */
    this.minDateRange = 2;
    /**
     * The selected from date range.
     * @type {Moment?}
     */
    this.selectedDateRangeFrom = null;
    /**
     * The selected to date range.
     * @type {Moment?}
     */
    this.selectedDateRangeTo = null;
  }
  /**
   * Evaluate the filter's collapse/expand status.
   */
  $onInit() {
    if (typeof (this.expanded) !== 'boolean') {
      this.expanded = true;
    }
  }
  /**
   * Its handle the given Date Objects to provide the implementation with the UTC version of
   * the dates when the a range is selected.
   *
   * @param {Date} selectedDates  the date Object provided by the plugin.
   */
  handleOnDateRangeChange(selectedDates) {
    if (selectedDates.length >= this.minDateRange) {
      this.selectedDateRangeFrom = this.moment(selectedDates[0]).startOf('day');
      this.selectedDateRangeTo = this.moment(selectedDates[1]).endOf('day');

      this.onDateRangeChange({
        from: this.selectedDateRangeFrom,
        to: this.selectedDateRangeTo,
      });
    }
  }
  /**
   * We shall check when the calendar is closed and the minimum number of dates were not selected,
   * we need to set the selected dates as the previous ones (if there are any selected).
   *
   * @property {Date}      selectedDates  the date Object provided by the plugin.
   * @property {String}    dateStr        the date string provided by the plugin.
   * @property {Flatpickr} instance       the flatpickr's intance returned by the plugin.
   */
  onCalendarClose(selectedDates, dateStr, instance) {
    if (
      selectedDates.length < this.minDateRange &&
      this.selectedDateRangeFrom &&
      this.selectedDateRangeTo
    ) {
      instance.setDate([
        this.selectedDateRangeFrom.toDate(),
        this.selectedDateRangeTo.toDate(),
      ]);
    }
  }
  /**
   * Collapse/expand the filter.
   */
  toggleExpansion() {
    this.expanded = !this.expanded;
  }
}

/**
 * @ngdoc component
 * @name odsFilterBarDate
 * @description
 * The filterBar date filter component.
 */
export default {
  /**
   * The controller class for the component.
   * @type {OdsFilterBarDate}
   */
  controller: OdsFilterBarDate,
  /**
   * The HTML template for the component.
   * @type {String}
   */
  template,
  /**
   * Component bindings
   * @type {Object}
   * @property {String}   calendarDefaultLabel  the Ods calendar's input value.
   * @property {String}   title                 the filter title.
   * @property {Boolean}  expanded              the collapse/expand status of the filter.
   * @property {Function} onDateRangeChange     the callback fired every time the user select a new date.
   * @property {Function} onInstanceReady       the callback fired every when the calendar plugin is ready.
   */
  bindings: {
    calendarDefaultLabel: '@',
    title: '@',
    expanded: '<',
    onDateRangeChange: '&',
    onInstanceReady: '&',
  },
};
